import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m24.78 7.829 1.96-2.156a1 1 0 0 0-1.48-1.345L23.3 6.483A11.994 11.994 0 0 0 7.22 24.17l-1.96 2.157a1.001 1.001 0 1 0 1.48 1.345l1.96-2.155a11.993 11.993 0 0 0 16.08-17.69M6 16a10 10 0 0 1 15.95-8.03L8.573 22.685A9.95 9.95 0 0 1 6 16m10 10a9.94 9.94 0 0 1-5.95-1.969L23.423 9.315A9.994 9.994 0 0 1 16 26"
    }, null, -1)
  ])))
}
export default { render: render }